import { useQuery } from "@apollo/client";
import { GET_BANKS, GET_CITIES, GET_WARDS_OF_CITY } from "graphql/common/query";

export const useCities = (ids) => {
  const { data, loading } = useQuery(GET_CITIES, { variables: { ids } });
  return {
    cities: data?.city?.list,
    loading,
  };
};

export const useWards = (cityID) => {
  const { data, loading, refetch } = useQuery(GET_WARDS_OF_CITY, {
    variables: { cityID: cityID },
    skip: !cityID,
  });
  return {
    wards: data?.ward?.listOfCity,
    loading,
    refetch,
  };
};

export const useBanks = () => {
  const { data, loading } = useQuery(GET_BANKS);
  return {
    banks: data?.bank?.pagination?.banks,
    loading,
  };
};
